import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Header from "./components/Header";
import NewsBanner from "./components/NewsBanner";
import Hero from "./components/Hero";
import About from "./components/About";
import Products from "./components/Products";
import Partners from "./components/Partners";
import News from "./components/News";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Support from "./components/Support";
import ProBatLanding from "./components/ProBatLanding";
import MasterSudokuChallengeLanding from "./components/MasterSudokuChallengeLanding";
import SparkleLanding from "./components/SparkleLanding";
import PassCryptLanding from "./components/PassCryptLanding";
import PandaGPTLanding from "./components/PandaGPTLanding";
import NF525Landing from "./components/NF525Landing";
import InternshipOffer from "./components/InternshipOffer";
import InternshipOfferEngineer from "./components/InternshipOfferEngineer";
import SEO from "./components/SEO";
import "./styles.css";

// Component to handle language routes
const LanguageRoute = ({ children, lang }) => {
  return children;
};

// Component to redirect root to appropriate language
const RootRedirect = () => {
  const browserLang =
    typeof window !== "undefined"
      ? navigator.language || navigator.userLanguage
      : "en";
  const langCode = browserLang.split("-")[0].toLowerCase();
  const defaultLang = langCode === "fr" ? "fr" : "en";
  return <Navigate to={`/${defaultLang}`} replace />;
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <LanguageProvider>
        <SEO />
        <div className="App">
          <Routes>
            {/* Root redirects to detected language */}
            <Route path="/" element={<RootRedirect />} />

            {/* Language-specific routes */}
            <Route
              path="/:lang"
              element={
                <LanguageRoute>
                  <Header />
                  {/* <NewsBanner /> */}
                  <main className="main-content">
                    <Hero />
                    <About />
                    <Products />
                    <Partners />
                    {/* <News /> */}
                    <Contact />
                  </main>
                  <Footer />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/privacy-policy"
              element={
                <LanguageRoute>
                  <PrivacyPolicy />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/support"
              element={
                <LanguageRoute>
                  <Support />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/probat"
              element={
                <LanguageRoute>
                  <ProBatLanding />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/master-sudoku-challenge"
              element={
                <LanguageRoute>
                  <MasterSudokuChallengeLanding />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/sparkle"
              element={
                <LanguageRoute>
                  <SparkleLanding />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/passcrypt"
              element={
                <LanguageRoute>
                  <PassCryptLanding />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/pandagpt"
              element={
                <LanguageRoute>
                  <PandaGPTLanding />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/nf525"
              element={
                <LanguageRoute>
                  <NF525Landing />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/stage-sales-marketing"
              element={
                <LanguageRoute>
                  <InternshipOffer />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/stage"
              element={
                <LanguageRoute>
                  <InternshipOffer />
                </LanguageRoute>
              }
            />
            <Route
              path="/:lang/stage-ingenieur"
              element={
                <LanguageRoute>
                  <InternshipOfferEngineer />
                </LanguageRoute>
              }
            />

            {/* Legacy routes without language - redirect to default language */}
            <Route
              path="/privacy-policy"
              element={<Navigate to="/en/privacy-policy" replace />}
            />
            <Route
              path="/support"
              element={<Navigate to="/en/support" replace />}
            />
            <Route
              path="/probat"
              element={<Navigate to="/en/probat" replace />}
            />
            <Route
              path="/master-sudoku-challenge"
              element={<Navigate to="/en/master-sudoku-challenge" replace />}
            />
            <Route
              path="/sparkle"
              element={<Navigate to="/en/sparkle" replace />}
            />
            <Route
              path="/passcrypt"
              element={<Navigate to="/en/passcrypt" replace />}
            />
            <Route
              path="/pandagpt"
              element={<Navigate to="/en/pandagpt" replace />}
            />
            <Route
              path="/nf525"
              element={<Navigate to="/en/nf525" replace />}
            />
            <Route
              path="/stage-sales-marketing"
              element={<Navigate to="/en/stage-sales-marketing" replace />}
            />
            <Route
              path="/stage"
              element={<Navigate to="/en/stage-sales-marketing" replace />}
            />
            <Route
              path="/stage-ingenieur"
              element={<Navigate to="/en/stage-ingenieur" replace />}
            />
          </Routes>
        </div>
      </LanguageProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
